module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-training-65e6437f344aee414b6bd6d6cd463047.svg";